import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import AuthCard from "~/components/auth/auth-card";
import ForgotPasswordForm from "~/components/auth/forgot-password-form";

export const Route = createFileRoute("/_auth/forgot-password")({
  component: ForgotPassword,
});

function ForgotPassword() {
  const { t } = useTranslation("common");
  return (
    <>
      <AuthCard title={t("Auth.forgot_password_title")}>
        <ForgotPasswordForm />
      </AuthCard>
    </>
  );
}
